import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;

  @media (max-width: 1150px) {
    flex-direction: column;
  }
`

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: 492px;
  height: 300px;
  padding: 16px;
  background: #eeeeee;
  border-radius: 8px;

  @media (max-width: 1150px) {
    width: auto;
    height: ${({ low }) => (low === 'true' ? '188px' : '300px')};
  }

  @media (max-width: 600px) {
    width: auto;
    height: ${({ low }) => (low === 'true' ? '166px' : '296px')};
  }
`
export const Ul = styled.ul`
  margin-left: 20px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #424242;

  li {
    ul {
      margin-left: 20px;
    }
  }
`

export const Campaing = styled.p`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: var(--blue);

  cursor: pointer;

  @media (max-width: 600px) {
    width: 7ch;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: clip;
  }
`

export const Text = styled.h3`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;

  color: var(--gray);

  @media (max-width: 600px) {
    font-size: 18px;
    line-height: 26px;
  }
`
